import React, {useEffect} from 'react';

import useCarousel from '@stencil/hook-use-carousel';
import {defaultTheme} from '@stencil/build-theme';

import HappyAngleLeftIcon from '@stencil/icons/src/HappyAngleLeftIcon/HappyAngleLeftIcon';
import HappyAngleRightIcon from '@stencil/icons/src/HappyAngleRightIcon/HappyAngleRightIcon';

import * as S from './Carousel.styles';

interface CarouselProps {
  options?: {
    emblaOptions?;
    topPosition?;
  };
  data: any[];
  preloadImagesOnInteraction?: boolean;
  imageUrlKeyName?: string;
  renderItem?: (item: any, index: number, isLastItem: boolean) => React.ReactNode;
  renderLeftIcon?: () => React.ReactNode;
  renderRightIcon?: () => React.ReactNode;
  onClickControlPanel?: (event) => void;
}

const defaultRenderLeftIcon = ({onClick, isDisabled}) => (
  <S.CarouselIconWrapper
    isDisabled={isDisabled}
    onClick={e => {
      e.stopPropagation();
      onClick(e);
    }}
  >
    <HappyAngleLeftIcon fill={defaultTheme.colors.goWhite.base} width="1.2rem" height="1.2rem" />
  </S.CarouselIconWrapper>
);
const defaultRenderRightIcon = ({onClick, isDisabled}) => (
  <S.CarouselIconWrapper
    isDisabled={isDisabled}
    onClick={e => {
      e.stopPropagation();
      onClick(e);
    }}
  >
    <HappyAngleRightIcon fill={defaultTheme.colors.goWhite.base} width="1.2rem" height="1.2rem" />
  </S.CarouselIconWrapper>
);

const Carousel: React.FC<CarouselProps> = ({
  options = {
    emblaOptions: {
      loop: false,
    },
  },
  data,
  preloadImagesOnInteraction = false,
  imageUrlKeyName = 'url',
  renderItem = (item, index, isLastItem) => item,
  renderLeftIcon = defaultRenderLeftIcon,
  renderRightIcon = defaultRenderRightIcon,
  onClickControlPanel = e => {},
}) => {
  const {emblaRef, scrollPrevious, scrollNext, tweenValues, leftArrowIsActive, rightArrowIsActive} =
    useCarousel(options);

  const {topPosition} = options;

  // adding preloading of images on first interaction of user(i.e., right button click of carousel)
  useEffect(() => {
    if (preloadImagesOnInteraction && leftArrowIsActive) {
      data?.forEach(item => {
        let img = new Image();
        img.src = item[imageUrlKeyName] || '';
      });
    }
  }, [data, leftArrowIsActive, preloadImagesOnInteraction]);

  if (!data?.length) return null;
  return (
    <S.CarouselContainer>
      <S.CarouselSlider ref={emblaRef}>
        <S.SliderWrap>
          {data?.map((slide, index) => (
            <S.CarouselSlide
              style={{
                ...(!!tweenValues?.length && {
                  transform: `scale(${tweenValues[index]})`,
                }),
              }}
              key={`${index}+1222`}
            >
              {renderItem(slide, index, index === data.length - 1)}
            </S.CarouselSlide>
          ))}
        </S.SliderWrap>
      </S.CarouselSlider>
      <S.CarouselControls $topPosition={topPosition} onClick={onClickControlPanel}>
        {renderLeftIcon({onClick: scrollPrevious, isDisabled: !leftArrowIsActive})}
        {renderRightIcon({onClick: scrollNext, isDisabled: !rightArrowIsActive})}
      </S.CarouselControls>
    </S.CarouselContainer>
  );
};

export default Carousel;
